import {
  Partners,
  QUOTE_TYPES,
  QUOTE_WORKFLOW_STATUSES,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';
import { createDefinition } from '@lockton-apps/shared/util/helpers';
import { WorkflowStatusMeta } from './interface';

const COMMON_VARIANTS = {
  [QUOTE_TYPES.Renewal + Partners.LSOS_ADDON]: {
    base: {
      label: $localize`Quote sent`,
      icon: 'quote_universal_sent_thin',
    },
  },
};

export const getEnquiryQuoteWorkflowMetaDef =
  createDefinition<WorkflowStatusMeta>({
    base: {
      label: $localize`Pending`,
      icon: 'more',
      level: 'info',
    },
    variants: {
      [QUOTE_WORKFLOW_STATUSES.ProposalComplete]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS]: {
                base: {
                  label: $localize`Quote ready to review`,
                  icon: 'quote_universal_thin',
                  level: 'info',
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteOnHold]: {
        base: {
          label: $localize`Quote on hold`,
          icon: 'quote_onhold_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteRequested]: {
        base: {
          label: $localize`Quote requested`,
          icon: 'quote_requested_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteSent]: {
        base: {
          label: $localize`Quote sent`,
          icon: 'quote_universal_sent_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteReady]: {
        base: {
          label: $localize`Quote ready`,
          icon: 'quote_universal_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.QuoteAccepted]: {
        base: {
          label: $localize`Quote accepted`,
          icon: 'quote_universal_accepted_thin',
          level: 'info',
        },
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]:
                COMMON_VARIANTS[QUOTE_TYPES.Renewal + Partners.LSOS_ADDON],
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.AwaitingPayment]: {
        base: {
          label: $localize`Quote accepted`,
          icon: 'quote_universal_accepted_thin',
          level: 'info',
        },
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [QUOTE_TYPES.Renewal]: {
                base: {},
                variants: {
                  [Partners.LSOS_ADDON]:
                    COMMON_VARIANTS[QUOTE_TYPES.Renewal + Partners.LSOS_ADDON],
                },
              },
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.PaymentProcessing]: {
        base: {
          label: $localize`Quote accepted`,
          icon: 'quote_universal_accepted_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.PaymentReceived]: {
        base: {
          label: $localize`Quote accepted`,
          icon: 'quote_universal_accepted_thin',
          level: 'info',
        },
      },
      [QUOTE_WORKFLOW_STATUSES.PolicyDocumentationSent]: {
        base: {
          label: $localize`Quote accepted`,
          icon: 'quote_universal_accepted_thin',
          level: 'info',
        },
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]:
                COMMON_VARIANTS[QUOTE_TYPES.Renewal + Partners.LSOS_ADDON],
            },
          },
        },
      },
      [QUOTE_WORKFLOW_STATUSES.NotTakenUp]: {
        base: {},
        variants: {
          [QUOTE_TYPES.Renewal]: {
            base: {},
            variants: {
              [Partners.LSOS_ADDON]: {
                base: {
                  label: $localize`Not taken up`,
                  icon: 'renewal_ntu_thin',
                  level: 'error',
                },
              },
            },
          },
        },
      },
    },
  });

export function getEnquiryQuoteWorkflowMeta(
  status: QuoteWorkflowStatus,
  quoteType: QuoteType,
  partner: Partners | 'DEFAULT' = 'DEFAULT'
) {
  return getEnquiryQuoteWorkflowMetaDef([status, quoteType, partner]);
}
